<template>
  <div id="divVirtualVisitWrapper">
    <div class="content-layout-fixer">
      <div id="div-gpt-ad-1587046762079-0"></div>
    </div>
    <div class="content-row">
      <div class="content-layout-fixer">
        <div class="chef-banner" :style="{ 'background-image': chefBannerBg }"></div>
      </div>
    </div>
    <VueWrapperNarrow>
      <div v-if="status" class="player-wrapper">
        <iframe id="ommaPlayer" :src="url" allowfullscreen></iframe>
      </div>
      <div v-html="disclaimerHtml" class="legal-warning"></div>
      <div class="virtual-visit-content">
        <VueText sizeLevel="9" weightLevel="2" color="grey-40"
          >Performans takibi sayfandan işlerini takip et!
        </VueText>
      </div>
      <div class="work-button">
        <BrandButton
          as="router-link"
          class="click-btn"
          :target="{
            name: workRoute,
          }"
        >
          <VueIcon
            class="work-button-icon"
            :iconName="icons.briefcase.name"
            :width="icons.briefcase.width"
            :height="icons.briefcase.height"
            iconColor="#d02d2c"
          />
          <VueText color="grey-40" sizeLevel="7" weightLevel="5">Performans Takibi</VueText>
        </BrandButton>
      </div>
    </VueWrapperNarrow>
  </div>
</template>

<script>
import VueText from '@/components/shared/VueText/VueText.vue';
import VueWrapperNarrow from '@/components/brand/VueWrapperNarrow/VueWrapperNarrow.vue';
import BrandButton from '@/components/brand/BrandButton/BrandButton.vue';
import RoutesSecure from '@/router/routes/RoutesSecure';
import gtmUtils from '@/mixins/gtmUtils.js';
import { VirtualVisit } from '@/services/Api/index';
import { mapGetters } from 'vuex';
import StorageHelper from '@/utils/storageHelper';
import { ICON_VARIABLES } from '@/constants/component.constants.js';
import { CONTENT_URL } from '@/constants/urls.constants.js';
import VueIcon from '@/components/shared/VueIcon/VueIcon';
import StaticContent from '@/services/Api/staticContents';
import RosetteInfo from '@/mixins/rosetteInfo.js';
import { reportError, reportWithMetadata } from '@/utils/errorMonitoring';

const VV_EVENT_SCHEMA = {
  'init-completed': ['sessionId', 'timePeriod.startDate'],
  session_details: ['customer_id', 'timePeriod.startDate'],
  'watch-report': ['content.totalTime', 'content.percentage', 'scenes'],
};

export default {
  name: 'VirtualVisit',
  mixins: [RosetteInfo, gtmUtils],
  data() {
    return {
      isEnteredWatchReport: false,
      PERCENTAGE_CONSTANTS: {
        COMPLETION_THRESHOLD: 90,
        FULL_COMPLETION: 100,
        ROSETTE_TRIGGER_THRESHOLD: 80,
      },
      workRoute: RoutesSecure.ManageMyBusiness.name,
      url: null,
      disclaimerHtml: null,
      status: true,
      viewDuration: 0,
      scenes: {},
      rawScenes: null,
      sceneMetadata: {},
      isInitStarted: false,
      lastWatchReport: null,
      sessionId: null,
      isBranching: false,
      initCompletedPayload: null,
      ctaScenes: [],
      surveyScenes: [],
      timePeriod: null,
      eventLog: {
        customerId: null,
        sessionId: null,
        timePeriod: null,
        duration: 0,
        viewDuration: 0,
        templates: null,
        status: 0,
        surveyResult: null,
      },
      customerAccumulatedPoints: 0,
      isFirstPlay: true,

      vvValidation: {
        MAX_REPORTS: 3,
        MESSAGE_MAX_LEN: 300,
        reportedSignatures: [],
        reportCount: 0,
      },
      vvSessionTrace: {
        MAX_TRACE: 50,
        createdAt: null,
        eventsReceived: [],
        lastError: null,
        reportedNoSourceEvent: false,
      },
    };
  },
  components: {
    VueText,
    BrandButton,
    VueWrapperNarrow,
    VueIcon,
  },
  computed: {
    ...mapGetters('app', ['getVirtualVisit', 'getActiveDowinList']),
    icons() {
      return ICON_VARIABLES;
    },
    chefBannerBg() {
      return `url(${CONTENT_URL}/Files/VirtualVisit/chef-banner.png)`;
    },
  },
  created() {
    this._onVqMessage = this.handleVqMessage.bind(this);
    this.vvSessionTrace.createdAt = Date.now();
    this.getVirtualVisitData();
    this.$store.dispatch('app/setOverlayFunction', false);
  },
  mounted() {
    //initialize google ads
    this.pushAds('large');
    this.setCustomerAccumulatedPoints();
  },
  beforeDestroy() {
    window.removeEventListener('message', this._onVqMessage);
  },
  methods: {
    getRawUrlParam(url, name) {
      if (!url) return null;
      const match = url.match(new RegExp('[?&]' + name + '=([^&]*)'));
      return match ? match[1] : null;
    },
    loadScriptFunc() {
      window.addEventListener('message', this._onVqMessage);
    },
    handleVqMessage(event) {
      const isVqMessage = typeof event.data == 'string';
      if (!isVqMessage) return;

      let vqMessage;
      try {
        vqMessage = JSON.parse(event.data);
      } catch (error) {
        return;
      }

      console.log('vqPostMessage', vqMessage);

      this.recordSessionTraceEvent(vqMessage.event, vqMessage.payload);
      this.validateEventPayload(vqMessage.event, vqMessage.payload);

      switch (vqMessage.event) {
        case 'init-start':
          this.handleInitStart();
          break;
        case 'ready-for-session-resume':
          this.resumeSession();
          break;
        case 'init-completed':
          this.handleInitCompleted(vqMessage.payload);
          break;
      }

      this.createEventLogModel(vqMessage.event, vqMessage.payload);
      this.triggerRefreshRosettes(vqMessage.payload);
    },
    resumeSession() {
      const ommaPlayer = document.getElementById('ommaPlayer');
      if (!ommaPlayer || !ommaPlayer.contentWindow) return;
      ommaPlayer.contentWindow.postMessage(
        JSON.stringify({
          event: 'resume-session',
          payload: this.rawScenes,
        }),
        '*',
      );
    },
    triggerRefreshRosettes(payload) {
      if (
        payload &&
        payload.content &&
        payload.content.percentage >= this.PERCENTAGE_CONSTANTS.ROSETTE_TRIGGER_THRESHOLD
      ) {
        this.getRosettesList();
        this.getRosetteRewardStatu();
      }
    },
    handleInitStart() {
      this.isInitStarted = true;
    },
    handleInitCompleted(payload) {
      if (!payload) return;
      this.initCompletedPayload = payload;
      this.sessionId = payload.sessionId || null;
      this.isBranching = !!payload.isBranching;
      this.ctaScenes = Array.isArray(payload.ctaScenes) ? payload.ctaScenes : [];
      this.surveyScenes = Array.isArray(payload.surveyScenes) ? payload.surveyScenes : [];
      this.timePeriod = payload.timePeriod || null;
      if (payload.timePeriod && payload.timePeriod.startDate) {
        this.eventLog.timePeriod = payload.timePeriod.startDate
          .split('/')
          .reverse()
          .join('-');
      }
      if (this.sessionId) {
        this.eventLog.sessionId = this.sessionId;
      }
    },
    normalizeScenes(scenes = {}) {
      return Object.entries(scenes).reduce((acc, [key, scene]) => {
        acc[key] = {
          title: scene.title || '',
          includeInWatch: typeof scene.includeInWatch === 'boolean' ? scene.includeInWatch : true,
          isInstantlyCompleted:
            typeof scene.isInstantlyCompleted === 'boolean' ? scene.isInstantlyCompleted : false,
          ...scene,
        };
        return acc;
      }, {});
    },
    getSceneMetadata(scenes = {}) {
      return Object.entries(scenes).reduce((acc, [key, scene]) => {
        acc[key] = {
          includeInWatch: scene.includeInWatch,
          isInstantlyCompleted: scene.isInstantlyCompleted,
        };
        return acc;
      }, {});
    },
    getSceneById(sceneId) {
      if (!sceneId) return null;
      if (this.scenes[sceneId]) return this.scenes[sceneId];
      return (
        Object.values(this.scenes).find(
          scene => scene.id === sceneId || scene.code === sceneId || scene.title === sceneId,
        ) || null
      );
    },
    isSceneInstantlyCompleted(sceneId) {
      const scene = this.getSceneById(sceneId);
      return !!scene?.isInstantlyCompleted;
    },
    getVirtualVisitData() {
      Promise.all([this.getVirtualVisitPeriod(), this.getVirtualVisitUrl()]).then(
        ([period, virtualVisitData]) => {
          setTimeout(() => {
            const activeDowinList = this.getActiveDowinList;
            const taskCount = Array.isArray(activeDowinList)
              ? activeDowinList.reduce((a, b) => a + b.taskCount, 0)
              : 0;

            const interval = Number(period);
            const url =
              virtualVisitData.url +
              (interval > 0 ? `&watchReportInterval=${interval}` : '') +
              `&ts=${Date.now()}` +
              `&points=${this.customerAccumulatedPoints}` +
              `&yapKazan=${taskCount}`;

            const customerId = this.getRawUrlParam(virtualVisitData.url, 'ID');
            if (customerId) {
              try {
                this.eventLog.customerId = decodeURIComponent(customerId);
              } catch (e) {
                reportError('Failed to decode customerId from virtual visit url', e);
                this.eventLog.customerId = null;
              }
            } else {
              reportError('VirtualVisit url is missing the ID param');
            }

            const disclaimerHtml = virtualVisitData.disclaimerHtml;
            this.rawScenes = virtualVisitData.scenes;
            this.scenes = this.normalizeScenes(virtualVisitData.scenes || {});
            this.sceneMetadata = this.getSceneMetadata(this.scenes);
            this.disclaimerHtml = disclaimerHtml;
            this.url = url;
            this.$store.dispatch('app/setVirtualVisit', url);
            this.loadScriptFunc();
          }, 100);
        },
      );
    },
    getVirtualVisitUrl() {
      return VirtualVisit.getVirtualVisit().then(res => {
        return res.data.Data;
      });
    },
    getVirtualVisitPeriod() {
      return StaticContent.getStaticContent('VirtualVisitPeriod').then(res => {
        let {
          Data: { content },
        } = res.data;
        return content;
      });
    },
    virtualVisitValidateFunc() {
      VirtualVisit.virtualVisitValidate({ ...this.eventLog }).then(res => {
        const data = res.data.Data.isValidUser;
        this.status = data;
      });
    },
    saveEventLog() {
      this.checkForMissingSourceEvents();

      const toInt = v => (Number.isFinite(v) ? v : 0);
      const payload = {
        ...this.eventLog,
        duration: toInt(this.eventLog.duration),
        viewDuration: toInt(this.eventLog.viewDuration),
        status: toInt(this.eventLog.status),
      };
      VirtualVisit.virtualVisitSaveLog(payload).then(res => {
        if (!res.data.Data) return;
        if (this.eventLog.status === 3) {
          this.pushDataLayerEvent('virtualVisit', {
            ...res.data.Data.virtualVisit,
          });
        }
      });
    },
    saveScenesLog() {
      VirtualVisit.virtualVisitSaveScenesLog({
        watchReportPayload: this.lastWatchReport,
        mappedTemplates: this.eventLog.templates,
      });
    },
    createEventLogModel(eventName, payload) {
      switch (eventName) {
        case 'play':
          this.dataLayerVideoEvent('Play');
          break;
        case 'pause':
          this.dataLayerVideoEvent('Pause');
          break;
        case 'fullscreen-enter':
          this.setFullScreen();
          break;
        case 'fullscreen-exit':
          this.removeFullScreen();
          break;
        case 'seek-end':
          this.dataLayerVideoEvent('Seeked');
          break;
        case 'replay':
          if (payload && payload.sessionId) {
            this.sessionId = payload.sessionId;
            this.eventLog.sessionId = payload.sessionId;
          }
          this.dataLayerVideoEvent('Replay');
          this.isFirstPlay = true;
          break;
        case 'watch-report':
          this.lastWatchReport = payload;
          this.virtualVisitSaveScenes(payload);
          this.setDuration(payload);
          this.setTemplates(payload);
          this.setStartedLog(payload);
          if (!this.isEnteredWatchReport) {
            this.isEnteredWatchReport = true;
            this.saveScenesLog();
          }
          break;
        case 'end':
          this.setFinishedLog();
          this.saveScenesLog();
          this.dataLayerVideoEvent('Watch to End');
          break;
        case 'ended':
          this.setEndedLog(payload);
          this.dataLayerVideoEvent('Watch to End');
          break;
        case 'custom':
          this.setCustomLog(payload);
          break;
        case 'action':
          this.handleActionEvent(payload);
          break;
        case 'scene-change':
          this.setSceneChange(payload);
          break;
        case 'error':
          this.saveError(payload);
          break;
      }
    },
    dataLayerVideoEvent(action) {
      this.pushDataLayerEvent('video', {
        name: 'virtual visit',
        action: action,
        url: this.url || '',
      });
    },
    handleActionEvent(rawPayload) {
      const payload = this.normalizeActionPayload(rawPayload);
      if (!payload.name) return;
      switch (payload.name) {
        case 'surveyResult':
          this.setSurveyLog(payload);
          break;
        case 'ctaCode':
          this.setCtaLog(payload);
          break;
        default:
          break;
      }
    },

    normalizeActionPayload(payload) {
      if (!payload) return {};
      if (payload.data) {
        const d = payload.data;
        if (d.type === 'cta') {
          return { name: 'ctaCode', value: d.buttonName };
        }

        if (d.type === 'survey' || d.type === 'surveyResult') {
          return { name: 'surveyResult', value: d.value };
        }
        return { name: d.type, value: d.value };
      }
      if (payload.name === 'ctaResult') {
        return { name: 'ctaCode', value: payload.value };
      }

      return payload;
    },
    setCtaLog(payload) {
      const buttonName = payload.value;
      if (!buttonName) {
        return;
      }
      this.saveEventLog();
    },
    setSceneChange(payload) {
      const sceneId = payload?.sceneId || payload?.scene?.id || payload?.code;
      if (sceneId && this.isSceneInstantlyCompleted(sceneId)) {
        this.eventLog.status = 4;
        this.saveEventLog();
        return;
      }
      this.saveEventLog();
    },
    setCustomLog(payload) {
      if (payload?.name === 'session_details') {
        this.setCustomerIdLog(payload);
      }
    },
    setCustomerIdLog(payload) {
      this.eventLog.customerId = payload.customer_id;
      const startDate = payload.timePeriod.startDate
        .split('/')
        .reverse()
        .join('-');
      this.eventLog.timePeriod = startDate;
      this.virtualVisitValidateFunc();
    },
    setDuration(payload) {
      this.eventLog.duration = parseInt(payload.content.totalTime);
      const pct = parseInt(payload.content.percentage);
      if (this.isBranching || Number.isNaN(pct)) {
        this.eventLog.viewDuration = 0;
        return;
      }
      this.eventLog.viewDuration = parseInt((this.eventLog.duration * pct) / 100);
      if (pct != 0) {
        this.eventLog.status = 4;
      }
    },
    setTemplates(payload) {
      this.eventLog.templates = Object.values(payload.scenes)
        .map(q => (q.title ? q.title.replace('Template', '').trim() : ''))
        .join(',');
    },

    setStartedLog(payload) {
      if (payload.content.percentage == 0 || this.isFirstPlay) {
        this.eventLog.duration = parseInt(payload.content.totalTime);
        this.eventLog.status = 1;
      }
      this.isFirstPlay = false;
    },
    setSurveyLog(payload) {
      this.eventLog.status = 2;
      this.eventLog.surveyResult = +payload.value;
      this.saveEventLog();
    },
    setEndedLog() {
      this.eventLog.status = 3;
      this.saveEventLog();
    },
    setFinishedLog() {
      if (this.lastWatchReport) {
        let payloadToUse = this.lastWatchReport;

        // Only set to 100% if actual progress is above threshold
        if (
          this.lastWatchReport.content.percentage > this.PERCENTAGE_CONSTANTS.COMPLETION_THRESHOLD
        ) {
          payloadToUse = {
            ...this.lastWatchReport,
            content: {
              ...this.lastWatchReport.content,
              percentage: this.PERCENTAGE_CONSTANTS.FULL_COMPLETION,
            },
          };
        }

        this.virtualVisitSaveScenes(payloadToUse);
        this.setDuration(payloadToUse);
        this.setTemplates(payloadToUse);
      }

      this.eventLog.status = 3;
      this.saveEventLog();
    },
    saveError(payload) {
      let errorObj = {
        type: payload.type,
        message: payload.message,
        error: payload.error,
        sessionId: payload.sessionId,
      };
      VirtualVisit.VirtualVisitException({ ...errorObj });
    },
    virtualVisitSaveScenes(payload) {
      const request = {
        scenes: {
          content: payload.content,
          scenes: payload.scenes,
        },
      };

      VirtualVisit.virtualVisitSaveScenes(request);
    },
    setFullScreen() {
      const iframe = document.getElementById('ommaPlayer');
      iframe.classList.add('fullscreen');
    },
    removeFullScreen() {
      const iframe = document.getElementById('ommaPlayer');
      iframe.classList.remove('fullscreen');
    },
    setCustomerAccumulatedPoints() {
      const customerDetail = new StorageHelper({
        id: process.env.VUE_APP_STORAGE_CURRENT_POS_DETAIL,
      }).get();

      customerDetail?.partners?.forEach(f => {
        if (f.code != 'PMI') return;
        this.customerAccumulatedPoints = f.point;
      });
    },

    recordSessionTraceEvent(eventName, payload) {
      const trace = this.vvSessionTrace;
      trace.eventsReceived.push({ event: eventName, ts: Date.now() });
      if (trace.eventsReceived.length > trace.MAX_TRACE) {
        trace.eventsReceived.shift();
      }
      if (eventName === 'error' && payload) {
        trace.lastError = { type: payload.type, message: this.vvSafeShape(payload.message) };
      }
    },
    checkForMissingSourceEvents() {
      const trace = this.vvSessionTrace;
      if (trace.reportedNoSourceEvent) return;

      const SOURCE_EVENTS = ['watch-report', 'end', 'ended', 'finished'];
      const hasSourceEvent = trace.eventsReceived.some(e => SOURCE_EVENTS.includes(e.event));
      if (hasSourceEvent) return;

      trace.reportedNoSourceEvent = true;
      reportWithMetadata('VirtualVisit save triggered before any duration/status source event', {
        eventsReceived: trace.eventsReceived,
        totalEventsReceived: trace.eventsReceived.length,
        msSinceCreated: trace.createdAt ? Date.now() - trace.createdAt : null,
        lastError: trace.lastError,
        sessionId: this.sessionId || null,
        isInitStarted: this.isInitStarted,
        urlHadId: !!this.getRawUrlParam(this.url, 'ID'),
        currentEventLogStatus: this.eventLog.status,
      });
    },

    validateEventPayload(eventName, payload) {
      let schemaKey = eventName;
      if (eventName === 'custom') {
        if (!payload || payload.name !== 'session_details') return;
        schemaKey = 'session_details';
      }
      const requiredPaths = VV_EVENT_SCHEMA[schemaKey];
      if (!requiredPaths) return;

      const missing = requiredPaths.filter(path => !this.hasPath(payload, path));
      if (missing.length === 0) return;

      this.reportInvalidPayload(schemaKey, payload, missing);
    },
    hasPath(obj, path) {
      let cur = obj;
      for (const key of path.split('.')) {
        if (cur == null || typeof cur !== 'object') return false;
        cur = cur[key];
      }
      return cur != null;
    },
    reportInvalidPayload(eventKey, payload, missing) {
      const v = this.vvValidation;
      const signature = `${eventKey}:${missing.join(',')}`;
      if (v.reportCount >= v.MAX_REPORTS || v.reportedSignatures.includes(signature)) return;
      v.reportedSignatures.push(signature);
      v.reportCount += 1;

      reportWithMetadata('VirtualVisit invalid event payload', {
        event: eventKey,
        missingFields: missing,
        receivedKeys: this.vvSafeKeys(payload),
        contentKeys: payload && payload.content ? this.vvSafeKeys(payload.content) : undefined,
        sessionId: this.sessionId || null,
        isInitStarted: this.isInitStarted,
        payloadPreview: this.vvSafeShape(payload),
      });
    },
    vvSafeKeys(obj) {
      try {
        if (obj && typeof obj === 'object') return Object.keys(obj);
        return String(obj);
      } catch (e) {
        return null;
      }
    },
    vvSafeShape(data) {
      try {
        return JSON.stringify(data).slice(0, this.vvValidation.MESSAGE_MAX_LEN);
      } catch (e) {
        return String(data).slice(0, this.vvValidation.MESSAGE_MAX_LEN);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content-row {
  height: initial;
  width: 100%;
}
.chef-banner {
  position: relative;
  background-size: cover;
  height: 344px;
  margin-left: 20px;
}
.video-wrapper {
  max-height: 361px;
  margin: 60px auto 0;
}
.virtual-visit-content {
  margin: 30px auto;
}
.margin-top-10 {
  margin-top: 10px;
}
.work-button {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  .click-btn {
    width: 50% !important;
    border-radius: 5px;
    padding: 1rem;
    font-family: 'Avenir Next';
    font-size: 1rem;
    padding: #000;
    box-shadow: 0 0 6px 0 rgba(157, 96, 212, 0.5);
    border: solid 2px transparent;
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)),
      linear-gradient(to left, #d20051, #ffa300);
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: 2px 1000px 1px #fff inset;
  }
  &-icon {
    margin-right: palette-space-level(12);
  }
}
.fullscreen {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 9999;
}
.player-wrapper {
  margin-top: 60px;
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
  #ommaPlayer {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
.legal-warning {
  padding: palette-space-level(15) palette-space-level(30);
  border: solid 2px #000;
  margin-top: palette-space-level(15);
  /deep/ul {
    li {
      font-size: palette-font-size-level('4');
    }
  }
}
</style>
